import { TERMINOLOGY } from '@shared/i18n/terminology';
import config from '@config/index';
import * as yup from 'yup';
import { parseCalendarDate } from '@shared/utils/date';
import { calendarDateSchema } from '@shared/schemas/calendarDate.schema';
import { PROJECT_DESCRIPTION_MAX_LENGTH, PROJECT_PARTICIPANTS_MAX } from '../constants';
import type { TProjectFormValues } from '../types';

export const DEFAULT_PROJECT_FORM: TProjectFormValues = {
  name: '',
  description: '',
  leads: [],
  members: [],
  startDate: null,
  dueDate: null,
};

export const projectFormSchema: yup.ObjectSchema<TProjectFormValues> = yup.object({
  name: yup.string().trim().required(`Enter a ${TERMINOLOGY.project.lower} name.`).max(config.ITEM_NAME_MAX_LENGTH),
  description: yup.string().defined().max(PROJECT_DESCRIPTION_MAX_LENGTH),
  leads: yup
    .array()
    .of(yup.string().required())
    .required()
    .min(1, `Select at least one ${TERMINOLOGY.project.lower} lead.`)
    .max(PROJECT_PARTICIPANTS_MAX),
  members: yup.array().of(yup.string().required()).required().max(PROJECT_PARTICIPANTS_MAX),
  startDate: calendarDateSchema,
  // WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/projects/services/projects.service.ts
  dueDate: calendarDateSchema.test('date-order', 'Due date must be on or after the start date.', (dueDate, context) => {
    const startDate = context.resolve(yup.ref<string | null>('startDate'));
    if (!startDate || !dueDate) return true;
    return !parseCalendarDate(startDate) || !parseCalendarDate(dueDate) || dueDate >= startDate;
  }),
});
